import { css } from '@emotion/react';

import { COLORS } from '~/styles/colors';

export const useStyles = () => {
  return {
    container: css`
      border-radius: 16px;
      padding: 12px 16px;
      border: 1px solid ${COLORS.grey200};
      background-color: ${COLORS.lightGray};
      margin-top: 12px;
    `,
    icons: css`
      display: flex;
      justify-content: right;
      align-items: center;
      width: 100%;
      gap: 24px;
    `,
    input: css`
      margin-top: 12px;
    `,
    imageTitle: css`
      margin-bottom: 8px;
      margin-top: 12px;
    `,
    header: css`
      display: flex;
      align-items: center;
      width: 100%;
    `,
    info: css`
      display: flex;
      align-items: center;
      gap: 8px;
      width: inherit;
    `,
    description: css`
      color: ${COLORS.grey400};
    `,
  };
};
